// import { sensors } from '@/utils/log';
import { setting_obj } from '@/settings/setting';

export const state = () => ({
  // 这里是全局数据保存的地方
  topbar: 0,
  server_env: {},
  client_env: {},
  banners: [],
  pluginBanners: [],
});
// 修改state里面的函数必须用到mutations里面的函数
export const mutations = {
  setTopbar(current_state, data) {
    // 每个 mutation 函数都可以接受到两个参数
    // 第一个是 state 对象本身
    // 第二是调用函数时额外添加的数据
    // 这里需要做的就是改变 state 数据
    // 这样外面调用这个函数, 并且传入数据, 即可改变当前的 userInfo 属性
    if (data) {
      current_state.topbar = data;
    }
  },
  setBanner(current_state, data) {
    if (data) {
      current_state.banners = data;
    }
  },
  setPluginBanner(current_state, data) {
    if (data) {
      current_state.pluginBanners = data;
    }
  },
  setServerEnv(current_state, data) {
    // 每个 mutation 函数都可以接受到两个参数
    // 第一个是 state 对象本身
    // 第二是调用函数时额外添加的数据
    // 这里需要做的就是改变 state 数据
    // 这样外面调用这个函数, 并且传入数据, 即可改变当前的 userInfo 属性
    if (data) {
      current_state.server_env = data;
    }
  },
  setClientEnv(current_state, data) {
    // 每个 mutation 函数都可以接受到两个参数
    // 第一个是 state 对象本身
    // 第二是调用函数时额外添加的数据
    // 这里需要做的就是改变 state 数据
    // 这样外面调用这个函数, 并且传入数据, 即可改变当前的 userInfo 属性
    if (data) {
      current_state.client_env = data;
    }
  },
};

export const actions = {
  getBanners({ commit }) {
    const bannerUrl = `${setting_obj.cmsCdnPath}/MGwebsite/community-operation.json?v=${Date.now()}`;
    this.$axios.get(bannerUrl).then((res) => {
      if (res?.data) {
        res.data.forEach((item) => {
          const { hash, ext } = item.cover;
          item.cover_url = `${setting_obj.cmsCdnPath}/${hash}${ext}`;
        });
      }
      commit('setBanner', res.data);
    }).catch((e) => {
      console.error(e);
    });
  },
  getPluginBanners({ commit }) {
    const bannerUrl = `${setting_obj.cmsCdnPath}/MGwebsite/plugin-operation.json?v=${Date.now()}`;
    this.$axios.get(bannerUrl).then((res) => {
      if (res?.data) {
        res.data.forEach((item) => {
          const { hash, ext } = item.cover;
          item.cover_url = `${setting_obj.cmsCdnPath}/${hash}${ext}`;
        });
      }
      commit('setPluginBanner', res.data);
    }).catch((e) => {
      console.error(e);
    });
  },
};
